import { render, staticRenderFns } from "./Lyrics.vue?vue&type=template&id=fcb5f30c&"
import script from "./Lyrics.vue?vue&type=script&lang=js&"
export * from "./Lyrics.vue?vue&type=script&lang=js&"
import style0 from "./Lyrics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports